import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const BlacklistAreaRBAC = {
  pageID: 'd99c9cfe32295216dd1ec3092817e3fd',
  elementID: {
    ViewPage: '3e470dfe60f49ec2e012ec4d1118a313',
    Detail: '87a89f227f5ae69df5a69421bb8094fa',
    Edit: 'f4559fd017e0e18a52a711ba86e45749',
    Delete: '87a87a37d45ae69df5a69421ac3d805c',
    Create: '9748588d845ae69df5a6983b94683835',
    BulkUploadIsochrone: 'ffb4e6452cd1e678013171ddab952012',
    BulkUploadCSV: 'fcc1d2717497847945b66aa5ce863bf6',
  },
} as const

export const useBlacklistAreaRBACPage = createUseRBAC(BlacklistAreaRBAC.elementID)

export type UseBlacklistAreaRBACPageType = ReturnType<typeof useBlacklistAreaRBACPage>
